import { Http } from '@mygpt/app/http';

export interface DeleteFAQsPropertyParams {
  // 数据集 ID
  datasetId: string;
  propertyId: string;
}

/**
 * 删除问答属性
 * @param params
 * @returns
 */
export const deleteFAQsPropertyService = (params: DeleteFAQsPropertyParams) => {
  const { datasetId, propertyId } = params;
  const { delete: deleteFn } = Http.use();
  return deleteFn(`/datasets/${datasetId}/faqs/property`, {
    params: {
      property_id: propertyId,
    },
  });
};

export const batchDeleteFAQsPropertyService = (params: { datasetId: string; propertyIds: string[] }) => {
  const { datasetId, propertyIds } = params;
  const { delete: _delete } = Http.use();
  return _delete(`/datasets/${datasetId}/faqs/property/batch`, {
    params: {
      property_ids: propertyIds.join(','),
    },
  });
};
